<script lang="tsx">
  import EditAccountForm from "./EditAccountForm.vue";
  import FormSkeleton from "./FormSkeleton.vue";

  export default {
    components: { FormSkeleton, EditAccountForm },
    props: EditAccountForm.props as (typeof EditAccountForm["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <EditAccountForm v-bind.attr="$attrs" v-bind.prop="$props as any"/>

    <template #fallback>
      <FormSkeleton width="100%" height="100%"/>
    </template>
  </Suspense>
</template>
